import React from 'react'

import clsx from 'clsx'

import ClickoutWrapper from 'components/ClickoutWrapper'
import { useEventContext } from 'context/EventContext'
import isClickOutUrl from 'helpers/isClickOutUrl'
import isPpcClickOutUrl from 'helpers/isPpcClickOutUrl'

import CtaButtonListing from '../CtaButtonListing'

import classes from './PricingPlansButton.module.scss'

/** @type {import("./types").default} */
const PricingPlansButton = ({
  pricingUrl,
  globalProductId,
  engagementComponent = 'product_pricing',
  fullWidth,
  ...props
}) => {
  const eventContext = useEventContext()

  if (!pricingUrl) {
    return null
  }

  const isClickOut = isClickOutUrl(pricingUrl) || isPpcClickOutUrl(pricingUrl)

  return (
    <ClickoutWrapper
      url={pricingUrl}
      isClickout={isClickOut}
      buyerIntentProductId={globalProductId}
      buyerIntentSourceLocation={`${engagementComponent}:pricing-plans`}
      buyerIntentTrackAdClick={isClickOut}
      className={clsx('PricingPlansButton', fullWidth && classes.isFullWidth)}
      {...eventContext.addEvent({
        engagementComponent,
        engagementDestination: 'go-to_vendor-website',
        engagementDetails: 'button_view-pricing-plans',
        name: 'engagement_product_clickout',
        productClickUUID: globalProductId,
      })}
    >
      <CtaButtonListing variant="contained" icon={['far', 'external-link']} component="div" {...props} fullWidth>
        view pricing plans
      </CtaButtonListing>
    </ClickoutWrapper>
  )
}

export default PricingPlansButton
